/* hm-ef-buy: galeria, wybór planu i przycisk zakupu.
   PRZYCISK (AGENTS.md pkt 9, jarvis-copy-lab/library/przycisk-zakupu): ustawia w koszyku DOKŁADNIE wybraną ilość wariantu
   (z planem subskrypcji, gdy jest) i przechodzi do kasy. Nigdy samo /cart/add:
     GET /cart.js → linie tego wariantu (jeśli są) do zera przez /cart/update.js (po kluczach) → /cart/add.js z ilością
     i selling_plan → /checkout. Inne produkty w koszyku zostają. Blokada drugiego kliknięcia (aria-busy), zdjęcie blokady
     na pageshow (powrót z kasy) i po 15 s. Błąd bez planu → permalink /cart/<wariant>:<ilość>; błąd z planem → komunikat
     (permalink nie niesie planu, kwota w kasie nie zgadzałaby się z ceną na stronie).
   ZAKŁADKI (27.10.2026): pakiety z data-tab="sub" niosą plan Loop (data-plan) i idą do koszyka z selling_plan.
   HREF przycisku przy pakiecie z planem = ta sama karta z ?plan=<key> (otwarcie w nowej karcie / klik przed skryptem nie wkłada
   subskrypcji do koszyka jako zakupu jednorazowego); przy zakupie jednorazowym = permalink /cart/<wariant>:<ilość>.
   PAKIETY (blok „Bundle”): gdy każdy pakiet ma swój wariant (radio data-variant, sekcja data-variants = wszystkie warianty
   produktu; runda 12, 22.10.2026) — przycisk ustawia DOKŁADNIE wybrany wariant × 1: linie WSZYSTKICH wariantów produktu do zera
   (zmiana pakietu nie zostawia starego), add.js wybranego, /checkout; błąd → permalink /cart/<wariant>:1. Gdy produkt nie ma
   wariantów pakietów, przycisk ma data-off: nic nie dodaje do koszyka; przyciski .js-buy z innych sekcji przewijają do bloku zakupu. Licznik [data-sale-timer] liczy do północy (czas widza). */
(function () {
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  function gallery(root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = [].slice.call(track.children), n = slides.length, cur = 0;
    var count = root.querySelector('[data-gal-count]'), dots = root.querySelectorAll('.gdots i'), thumbs = root.querySelectorAll('[data-gal-thumbs] button');
    function set(i) {
      cur = i;
      if (count) count.textContent = (i + 1) + ' / ' + n;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      vsync();
    }
    // Slajdy wideo (runda 20): źródła i poster podpinane przy pierwszym zbliżeniu (sąsiedni slajd), gra tylko aktywny slajd,
    // pauza poza nim i gdy galeria zjedzie z ekranu; przy ograniczonym ruchu poster i start dopiero po dotknięciu.
    var vids = slides.map(function (s) { var b = s.querySelector('[data-gal-vid]'); return b ? { box: b, v: b.querySelector('video'), ready: false, user: false } : null; });
    var onScreen = true;
    function prime(x) {
      if (!x || x.ready) return;
      x.ready = true;
      if (x.v.dataset.poster) x.v.setAttribute('poster', x.v.dataset.poster);
      [].forEach.call(x.v.querySelectorAll('source[data-src]'), function (so) { so.setAttribute('src', so.dataset.src); });
      x.v.setAttribute('preload', 'metadata'); x.v.load();
    }
    function vsync() {
      vids.forEach(function (x, k) {
        if (!x) return;
        if (Math.abs(k - cur) <= 1) prime(x);
        var want = k === cur && onScreen && (!RM || x.user);
        if (want) { if (x.v.paused) { var p = x.v.play(); if (p && p.catch) p.catch(function () { x.box.classList.add('paused'); }); } }
        else if (!x.v.paused) x.v.pause();
      });
    }
    vids.forEach(function (x) {
      if (!x) return;
      if (RM) x.box.classList.add('paused');
      x.v.addEventListener('playing', function () { x.box.classList.remove('paused'); x.box.classList.add('playing'); });
      x.v.addEventListener('pause', function () { x.box.classList.remove('playing'); if (RM || x.user) x.box.classList.add('paused'); });
      var b = x.box.querySelector('[data-gal-play]');
      if (b) b.addEventListener('click', function () { prime(x); if (x.v.paused) { x.user = true; x.box.classList.remove('paused'); x.v.play(); } else { x.v.pause(); } });
    });
    if (vids.some(Boolean) && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { onScreen = e.isIntersecting; vsync(); }); }, { threshold: 0.25 }).observe(track);
    }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? 'auto' : 'smooth' }); }
    var prev = root.querySelector('[data-gal-prev]'), next = root.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) set(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  function addBiz(d, k) { while (k > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k--; } return d; }

  function init(root) {
    if (!root || root.dataset.hmInit) return;
    root.dataset.hmInit = '1';
    gallery(root);
    if (root.classList.contains('grad')) { // tło: róż kończy się w połowie zdjęcia galerii (--gm od góry sekcji)
      var gm = function () {
        var g = root.querySelector('.gal'); if (!g) return;
        var y = g.offsetHeight / 2, el = g;
        while (el && el !== root) { y += el.offsetTop; el = el.offsetParent; }
        root.style.setProperty('--gm', Math.round(y) + 'px');
      };
      gm(); var gw = innerWidth;
      window.addEventListener('resize', function () { if (innerWidth !== gw) { gw = innerWidth; gm(); } });
    }
    var cfg = {}; try { cfg = JSON.parse(root.querySelector('[data-hm-buy-config]').textContent); } catch (e) {}
    var lang = document.documentElement.lang || 'en';
    root.querySelectorAll('[data-arrives]').forEach(function (el) {
      el.textContent = addBiz(new Date(), cfg.days || 5).toLocaleDateString(lang.indexOf('-') > 0 ? lang : 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    });

    var VID = root.dataset.variant, form = root.querySelector('form.buy-form'), btn = root.querySelector('[data-hm-buy]');
    var label = btn.querySelector('[data-buy-label]'), renew = root.querySelector('[data-renew-line]'), err = root.querySelector('[data-buy-err]');
    var payAmt = root.querySelector('[data-pay-amt]'), timer = root.querySelector('[data-sale-timer]');
    if (timer) {
      var z = function (x) { return (x < 10 ? '0' : '') + x; };
      var tick = function () { var n = new Date(), e = new Date(n); e.setHours(24, 0, 0, 0); var d = Math.max(0, Math.floor((e - n) / 1000)); timer.textContent = z(Math.floor(d / 3600)) + ':' + z(Math.floor(d % 3600 / 60)) + ':' + z(d % 60); };
      tick(); setInterval(tick, 1000);
    }
    var payt = root.querySelector('[data-payt]'), radios = [].slice.call(root.querySelectorAll('input[name=hm_plan]'));
    var state = { qty: 1, plan: '', vid: VID };
    var VIDS = (root.dataset.variants || VID).split(',');
    // Zakładki Subscribe & Save / One Time Purchase (27.10.2026): przełączenie pokazuje pakiety zakładki i zaznacza pakiet
    // na tej samej pozycji (albo domyślny z data-def, albo pierwszy). Pakiet subskrypcji bez planu (data-noplan) wyłącza przycisk.
    var tabs = [].slice.call(root.querySelectorAll('[data-ptab]'));
    function tabCards(t) { return [].slice.call(root.querySelectorAll('.bnd[data-tab="' + t + '"]')); }
    function showTab(t, pick) {
      if (!tabs.length) return;
      var cur = checked(), from = cur && cur.closest('.bnd'), idx = from ? tabCards(from.dataset.tab).indexOf(from) : -1;
      tabs.forEach(function (b) { var on = b.dataset.ptab === t; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.querySelectorAll('.bnd[data-tab]').forEach(function (c) { c.hidden = c.dataset.tab !== t; });
      var cs = tabCards(t), r = pick;
      if (!r && idx > -1 && cs[idx]) r = cs[idx].querySelector('input[name=hm_plan]');
      if (!r) cs.forEach(function (c) { var x = c.querySelector('input[data-def]'); if (x && !r) r = x; });
      if (!r && cs[0]) r = cs[0].querySelector('input[name=hm_plan]');
      if (r) { r.checked = true; apply(r, false); }
    }
    function tabOf(r) { var c = r && r.closest('.bnd[data-tab]'); return c ? c.dataset.tab : ''; }
    tabs.forEach(function (b) { b.addEventListener('click', function () { if (!b.classList.contains('on')) showTab(b.dataset.ptab); }); });

    function apply(r, keepPlace) {
      var card = r.closest('.plan,.once'), anchor = r.closest('label') || card, t0 = anchor ? anchor.getBoundingClientRect().top : 0, d = r.dataset; // trzymamy w miejscu klikniętą etykietę, nie całą kartę (nad etykietą może pojawić się plakietka)
      root.querySelectorAll('.plan,.once').forEach(function (c) { c.classList.toggle('on', c.contains(r)); });
      if (keepPlace && anchor) requestAnimationFrame(function () { window.scrollBy({ top: anchor.getBoundingClientRect().top - t0, left: 0, behavior: 'instant' }); });
      state.qty = parseInt(d.qty, 10) || 1;
      state.plan = d.plan || '';
      state.vid = d.variant || VID;
      setLabel(label, d.label, d.labelWas);
      renew.textContent = d.renew;
      root.querySelectorAll('[data-ship-line]').forEach(function (s) { s.textContent = d.ship; });
      if (payt) payt.hidden = !d.once;
      if (payAmt && d.pay) payAmt.textContent = d.pay;
      btn.setAttribute('href', (state.plan || tabOf(r) === 'sub') ? location.pathname + (d.key ? '?plan=' + encodeURIComponent(d.key) : '') : '/cart/' + state.vid + ':' + state.qty);
      if (d.noplan) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
      document.querySelectorAll('.js-buy .lbl').forEach(function (l) { setLabel(l, d.label, d.labelWas); });
      var det = { title: d.stTitle, sub: d.stSub, button: d.stBtn, label: d.label };
      window.HM = window.HM || {}; window.HM.plan = det;
      document.dispatchEvent(new CustomEvent('hm:plan', { detail: det }));
    }
    function setLabel(el, text, was) { // tekst przycisku + opcjonalnie przekreślona cena compare-at (data-label-was, z Liquida)
      el.textContent = text;
      if (was) { el.appendChild(document.createTextNode(' ')); var s = document.createElement('s'); s.className = 'btn-was'; s.textContent = was; el.appendChild(s); }
    }
    function checked() { return radios.filter(function (r) { return r.checked; })[0]; }
    radios.forEach(function (r) { r.addEventListener('change', function () { apply(r, true); }); });
    var q = new URLSearchParams(location.search).get('plan'), start = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (q) radios.forEach(function (r) { if (r.dataset.key === q) start = r; });
    if (start && tabs.length && tabOf(start)) showTab(tabOf(start), start);
    else if (start) { start.checked = true; apply(start, false); }

    function release() { btn.removeAttribute('aria-busy'); }
    function fail() {
      if (state.plan) { release(); err.hidden = false; return; }
      window.location.href = '/cart/' + state.vid + ':' + state.qty;
    }
    function post(url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.hasAttribute('data-off')) { // pakiety bez mechanizmu w sklepie: nic do koszyka
        var bx = root.querySelector('.buy');
        if (!e.isTrusted && bx) bx.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      if (btn.getAttribute('aria-busy') === 'true' || btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var cur = checked(); // stan z zaznaczonego radia w chwili kliku (po „wstecz” przeglądarka przywraca zaznaczenie bez zdarzenia change)
      if (cur) { state.qty = parseInt(cur.dataset.qty, 10) || 1; state.plan = cur.dataset.plan || ''; state.vid = cur.dataset.variant || VID; }
      err.hidden = true;
      var plan = state.plan;
      var appPlan = form && form.querySelector('[name="selling_plan"]');
      if (!radios.length && appPlan && appPlan.value) plan = appPlan.value; // plan wybrany w bloku aplikacji subskrypcji
      var item = { id: parseInt(state.vid, 10), quantity: state.qty };
      if (plan) item.selling_plan = parseInt(plan, 10);
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (cart) {
          var zero = {}, any = false;
          (cart.items || []).forEach(function (it) { if (VIDS.indexOf(String(it.variant_id)) > -1) { zero[it.key] = 0; any = true; } });
          return any ? post('/cart/update.js', { updates: zero }) : null;
        })
        .then(function () { return post('/cart/add.js', { items: [item] }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(fail);
      setTimeout(release, 15000);
    });
    window.addEventListener('pageshow', function () { release(); var c = checked(); if (c && tabs.length && tabOf(c)) showTab(tabOf(c), c); else if (c) apply(c, false); });
  }
  function all() { document.querySelectorAll('[data-hm-buy-section]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', all);
})();
